import * as Yup from 'yup';
import { EFormTags } from '../../shared/interfaces/form-interfaces';

export const form = [
  {
    id: 'SignupForm',
    items: [
      {
        name: 'firstName',
        label: 'Nome',
        tag: EFormTags.textField,
      },
      {
        name: 'lastName',
        label: 'Sobrenome',
        tag: EFormTags.textField,
      },
      {
        name: 'email',
        type: 'email',
        label: 'Email',
        tag: EFormTags.textField,
      },
      {
        name: 'whatsapp',
        type: 'text',
        label: 'Whatsapp',
        tag: EFormTags.whatsapp,
      },
      {
        name: 'password',
        type: 'password',
        label: 'Senha',
        tag: EFormTags.textField,
      },
      {
        name: 'password2',
        type: 'password',
        label: 'Confirmar senha',
        tag: EFormTags.textField,
      },
    ],
  },
];

export const schema = Yup.object().shape({
  email: Yup.string()
    .required('Email é obrigatório')
    .email('Digite um email válido'),
  firstName: Yup.string()
    .required('Nome é obrigatório')
    .min(3, 'No mínimo 3 dígitos'),
  lastName: Yup.string()
    .required('Sobrenome é obrigatório')
    .min(3, 'No mínimo 3 dígitos'),
  password: Yup.string().min(8, 'No mínimo 8 dígitos'),
  password2: Yup.string()
    .min(8, 'No mínimo 8 dígitos')
    .oneOf([Yup.ref('password'), null], 'Senhas não coincidem'),
});

export const initialData = {
  email: '',
  whatsapp: '',
  firstName: '',
  lastName: '',
  password: '',
  password2: '',
};
